import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHelper } from '@app/common/http-helper';
import { Observable } from 'rxjs';
import { catchError, concatMap, map, shareReplay } from 'rxjs/operators';
import { CacheService } from './cache.service';
import { SphomeService } from './sphome.service';

@Injectable({
  providedIn: 'root'
})
export class MyFollowedSitesService {

  public useCache = true;
  private readonly cacheKeyPrefix = 'MyFollowedSitesService';

  private getMyFollowedSitesFromSpHome$ = new Map<string, Observable<Array<any>>>();

  constructor(private http: HttpClient,
              private cache: CacheService,
              private spHomeService: SphomeService,
              private httpHelper: HttpHelper) { }

  getMyFollowedSitesFromSpHome(start: number = 0, count: number = 10) {
    const params = `${start.toString()}-${count.toString()}`;
    if (this.getMyFollowedSitesFromSpHome$.has(params)) {
      return this.getMyFollowedSitesFromSpHome$.get(params);
    } else {
      const cacheKey = `${this.cacheKeyPrefix}-${'getMyFollowedSitesFromSpHome'}-${start.toString()}-${count.toString()}`;

      this.getMyFollowedSitesFromSpHome$.set(params, this.spHomeService.getSPHomeContext()
        .pipe(concatMap(ctx => {
          const httpHeaders = new HttpHeaders().append('SPHome-ApiContext', ctx.Payload);
          return this.http.get<any>(`${ctx.Urls[0]}/api/v1/sites/followed?mostRecentFirst=true&start=${start}&count=${count}&fillSiteData=true`, {
            headers: httpHeaders
          })
            .pipe(
              map(data => {
                this.useCache && this.cache.set(cacheKey, data.Items);
                return data.Items;
              }));
        }))
        .pipe(
          catchError(this.httpHelper.handleError({ operation: 'getMyFollowedSitesFromSpHome', result: [], rethrow: true, cacheKey: cacheKey })),
          shareReplay({ bufferSize: 1, refCount: true })));

      return this.getMyFollowedSitesFromSpHome$.get(params);
    }
  }
}
